import { objectsRHandler } from '@/utils/objectsRHandler';

import QuestionModel from '../list/question/index';

const API_PATH = 'poll-questions';

export const QuestionManager = {
  objects: objectsRHandler(API_PATH, QuestionModel),
};
